import z from "zod";
export const DTOWorkspaceRole = z.enum([
    "Owner",
    "Admin",
    "Creator",
    "Viewer",
    "Billing",
    "Contributor",
]);
export const DTOWorkspaceSeatType = z.enum(["Full", "Builder", "None"]);
export const DTOWorkspaceBilledSeatType = z.enum(["Full", "Builder"]);
export const DTOBillingInterval = z.enum(["daily", "monthly", "yearly"]);
export const DTOProductCode = z.enum([
    "free",
    "pro",
    "team",
    "company",
    "enterprise",
]);
